import { createFileRoute } from '@tanstack/react-router';
import { ContactsPage } from '@/features/accounting/contacts-page';
import { AccountingGuard } from '@/features/accounting/guard';

export const Route = createFileRoute('/_app/accounting/contacts')({
  // ?c=<id> — the contact ⌘K picked opens straight on its card
  validateSearch: (s: Record<string, unknown>): { c?: string } => ({ c: typeof s.c === 'string' && s.c ? s.c : undefined }),
  component: function Contacts() {
    const { c } = Route.useSearch();
    return (
      <AccountingGuard>
        <ContactsPage contactId={c} />
      </AccountingGuard>
    );
  },
});
